import HomeV2Container from "@/containers/HomeV2/HomeV2Container";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { landingFunnelKey } from "@/constants/funnelRouteDeclareValues";
import { sessionStorage, storageKeys } from "@/utils/storage";
import Head from "next/head";
import { getCdnImageSrc } from "goi_common";
const HOME_URL = "https://prime.goifuneral.co.kr/";

const carouselStructuredData = {
  "@context": "http://schema.org",
  "@type": "ItemList",
  itemListElement: [
    {
      "@type": "ListItem",
      item: {
        "@type": "Organization",
        name: "치솟는 장례 비용 평생 고정",
        image: getCdnImageSrc("direct/home-richsearch/c-1-1.png"),
        url: HOME_URL,
      },
      position: "1",
    },
    {
      "@type": "ListItem",
      item: {
        "@type": "Organization",
        name: "타 상조 대비 절반 비용",
        image: getCdnImageSrc("direct/home-richsearch/c-1-2.png"),
        url: HOME_URL,
      },
      position: "2",
    },
    {
      "@type": "ListItem",
      item: {
        "@type": "Organization",
        name: "중도 해지 시 전액 환급",
        image: getCdnImageSrc("direct/home-richsearch/c-1-3.png"),
        url: HOME_URL,
      },
      position: "3",
    },
    {
      "@type": "ListItem",
      item: {
        "@type": "Organization",
        name: "정부 인증 소비자 중심 기업",
        image: getCdnImageSrc("direct/home-richsearch/c-1-4.png"),
        url: HOME_URL,
      },
      position: "4",
    },
    {
      "@type": "ListItem",
      item: {
        "@type": "Organization",
        name: "5년 연속 최고브랜드 대상",
        image: getCdnImageSrc("direct/home-richsearch/c-1-5.png"),
        url: HOME_URL,
      },
      position: "5",
    },
  ],
};

const TOSS_VERIFICATION_CAMPAIGNS = [
  "toss_may_tossform_260604_01_01",
  "toss_may_tossform_260604_01_02",
  "toss_may_tossform_260604_01_03",
  "toss_may_tossform_260604_01_04",
  "toss_may_tossform_260604_01_05",
  "toss_may_tossform_260604_01_06",
  "toss_m_banner_260609_01",
  "toss_m_banner_260609_02",
];

export default function HomePage() {
  const router = useRouter();

  const utmCampaign = router.query?.utm_campaign as string | undefined;
  const isTossVerification =
    !!utmCampaign && TOSS_VERIFICATION_CAMPAIGNS.includes(utmCampaign);

  // useLandingPageEffect(자식 useEffect)가 Platform을 초기화한 뒤 실행되도록
  // 부모 useEffect에서 세팅 (React: 자식 effect → 부모 effect 순서)
  useEffect(() => {
    if (isTossVerification) {
      sessionStorage.set(storageKeys.Platform, "toss");
    }
  }, [isTossVerification]);

  // 카카오뱅크 리워드 포스트백용 쿼리 저장
  useEffect(() => {
    if (!router.isReady) return;
    const { kakaobank, kuid } = router.query;
    if (typeof kakaobank === "string") {
      sessionStorage.set(storageKeys.kakaobank, kakaobank);
    }
    if (typeof kuid === "string") {
      sessionStorage.set(storageKeys.kuid, kuid);
    }
  }, [router.isReady, router.query]);

  if (!router.isReady) return null;

  const fnkFromQuery = router.query?.fnk as string | undefined;

  const isKakaobank =
    fnkFromQuery === landingFunnelKey.GROUP.kakao_bank_mt ||
    (router.query?.utm_source === "kakaobank" &&
      router.query?.utm_medium === "paid" &&
      router.query?.utm_campaign?.includes("homebanner_0215_1"));

  const funnelKey = isKakaobank
    ? landingFunnelKey.GROUP.kakao_bank_mt
    : isTossVerification
    ? landingFunnelKey.GROUP.toss_100
    : undefined;

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(carouselStructuredData),
          }}
        />
      </Head>
      <HomeV2Container funnelKey={funnelKey} />
    </>
  );
}
